<template>
    <div class="inner_card">
        <div class="card_title">
            {{ parcours.nom }}
        </div>
        <div>{{ parcours.metadata.date_course }} {{ parcours.metadata.heure_depart }}</div>
        <hr class="my-2">
        <FeaturedRunnerSection :favorites="parcours.featured_runners_favorites"
            :finishers="parcours.featured_runners_finishers" />
        <hr class="my-2">

        <div v-if="parcours.is_live" class="d-flex flex-row justify-content-center align-items-center gap-2">

            <router-link :to="{ name: 'Parcours', params: { course: parcours.nom } }">
                <button class="btn-parcours-card"><b-icon icon="map" aria-hidden="true"></b-icon></button>
            </router-link>

            <router-link v-if="$store.state.showParticipantsTab && !$store.state.hide_nb_inscrits"
                :to="{ path: '/' + this.$store.state.module.base + '/inscriptions' }">
                <button class="btn-parcours-card"><b-icon icon="person" aria-hidden="true"></b-icon></button>
            </router-link>
            <router-link v-else-if="!$store.state.hide_nb_inscrits"
                :to="{ name: 'Live', params: { course: parcours.nom, tab: 'participants' } }">
                <button class="btn-parcours-card"><b-icon icon="person" aria-hidden="true"></b-icon></button>
            </router-link>
            <router-link :to="{ name: 'Live_Passages', params: { course: parcours.nom, tab: 'passages' } }">
                <button class="btn-parcours-card"><b-icon icon="geo" aria-hidden="true"></b-icon></button>
            </router-link>
            <router-link :to="{ name: 'Live_Podiums', params: { course: parcours.nom, tab: 'podiums' } }"><button
                    class="btn-parcours-card"><b-icon icon="trophy" aria-hidden="true"></b-icon></button></router-link>
            <router-link v-if="!$store.state.hide_nb_inscrits"
                :to="{ name: 'Resultats', params: { course: parcours.nom } }"><button class="btn-parcours-card"><b-icon
                        icon="list-ol" aria-hidden="true"></b-icon></button></router-link>
        </div>


    </div>
</template>

<script>
import FeaturedRunnerSection from "@/components/Courses_tab/FeaturedRunnerSection.vue";
export default {
    components: { FeaturedRunnerSection },
    props: ["parcours"],
}
</script>

<style lang="scss" scoped></style>